import http from '@/http';

export const TransferenciaService = {
  async gerarRelatorioTransferencia(dados, onProgress = null) {
    try {
      const safra = dados.safra;
      const cdCooperado = dados.cdCooperado;

      if (!cdCooperado || !safra) {
        throw new Error('Cooperado e Safra são obrigatórios');
      }

      const config = onProgress ? {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      } : {};

      const response = await http.get(`/api/astec/projetos/transferencia/${cdCooperado}/${safra}`, {
        ...config,
        responseType: 'blob'
      });

      return response.data;

    } catch (error) {
      console.error("Erro ao gerar relatório de transferência:", error);
      throw error;
    }
  }
};
